(function ($) {
  var wishListsArr = localStorage.getItem('wishListsArr') ? JSON.parse(localStorage.getItem('wishListsArr')) : [];
  localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));
  if (wishListsArr.length) {
    wishListsArr = JSON.parse(localStorage.getItem('wishListsArr'));
  };


  var nuranium = {
    init: function () {
      this.closeModal();
      this.novProductTabs();

      this.initNovWishListIcons();
      this.doAddOrRemoveWishlist();

      if ($('body').hasClass('template-page') && $('.wishlist-page').length) {
        this.initNovWishListsPage();
      };

      this.ajaxProductAddToCart();
      this.ajaxAddToCart();
      this.ajaxChangeFromCart();
      this.initMiniCart();
      this.ajaxRemoveFromCart();
      this.initQuickView();
      this.initQuickVariants();
      this.changeQuantityPageCart();
    },

    closeModal: function () {
      $('.close-modal, .overlay').click(function () {
        $('.loading-modal').css({ "opacity": "0", "visibility": "hidden", "transform": "translateX(410px)", "transition": "all 0.3s" });;
      });
    },

    novProductTabs: function () {
      var productTabs = $('[data-product-tabs]');

      productTabs.each(function () {
        var self = $(this),
          listTabs = self.find('.list-product-tabs'),
          tabLink = listTabs.find('[data-product-tabTop]'),
          tabContent = self.find('[data-product-TabContent]'),
          linkActive = self.find('.list-product-tabs .tab-links.active'),
          activeTab = self.find('.product-tabs-content .tab-content.active');

        nuranium.doAjaxNovProductTabs(linkActive.data('href'), activeTab.find('.loading'), activeTab.find('.products-grid'));

        tabLink.off('click').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if ($(this).hasClass('active')) {
            return;
          }

          if (!$(this).hasClass('active')) {
            var curTab = $(this),
              curTabContent = $(curTab.data('target'));

            tabLink.removeClass('active');
            tabContent.removeClass('active');

            if (!curTabContent.find('.products-grid').hasClass('slick-initialized')) {
              nuranium.doAjaxNovProductTabs(curTab.data('href'), curTabContent.find('.loading'), curTabContent.find('.products-grid'));
            }

            curTab.addClass('active');
            curTabContent.addClass('active');
          }
        });
      });
    },

    doAjaxNovProductTabs: function (handle, loadingElement, curTabContent) {
      $.ajax({
        type: "GET",
        url: window.router + handle,
        success: function (data) {
          loadingElement.hide();

          if (handle == '/collections/?view=json' || handle == '/collections/?view=new-json') {

          } else {
            curTabContent.html($(data).find('.grid-item').html());
            if (curTabContent.hasClass('collection-carousel')) {
              if (!curTabContent.hasClass('slick-initialized')) {
                nuranium.initNovProductTabsSlider(curTabContent.parent());
              };
            } else {
              var row = curTabContent.data('items');
              switch (row) {
                case 1:
                  var _class = 'col-lg-12';
                  break;
                case 2:
                  var _class = 'col-lg-6';
                  break;
                case 3:
                  var _class = 'col-lg-4';
                  break;
                case 4:
                  var _class = 'col-lg-3';
                  break;
                case 5:
                  var _class = 'col-lg-5';
                  break;
                case 6:
                  var _class = 'col-lg-2';
                  break;
              }
            };

            curTabContent.find('.grid-item').addClass(_class);

            Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

            nuranium.initNovWishListIcons();

            /*setTimeout(function () {
                if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
                    return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                };
            }, 1000);*/
          };
        }
      });
    },

    initNovProductTabsSlider: function (tabslider) {
      tabslider.each(function () {
        var self = $(this),
          productGrid = self.find('.products-grid'),
          t = !!$("html").hasClass("lang-rtl");

        if (productGrid.not('.slick-initialized')) {
          productGrid.slick({
            nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right" aria-hidden="true"></i></div>',
            prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left" aria-hidden="true"></i></i></div>',
            rtl: t,
            slidesToShow: (productGrid.data("loop"), productGrid.data("items")),
            slidesToScroll: (productGrid.data("loop"), productGrid.data("items")),
            rows: productGrid.data("row"),
            arrows: productGrid.data("nav"),
            dots: productGrid.data("dots"),
            infinite: productGrid.data("loop"),
            adaptiveHeight: !0,
            responsive: [
              {
                breakpoint: 1920,
                settings: {
                  slidesToShow: (
                    productGrid.data("loop"),
                    productGrid.data("items")
                  ),
                  slidesToScroll: (productGrid.data("loop"),
                    productGrid.data("items"))
                }
              },
              {
                breakpoint: 1439,
                settings: {
                  slidesToShow: productGrid.data("items_lg_desktop"),
                  slidesToScroll: productGrid.data("items_lg_desktop")
                }
              },
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: productGrid.data("items_lg_tablet"),
                  slidesToScroll: productGrid.data("items_lg_tablet")
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: productGrid.data("items_tablet"),
                  slidesToScroll: productGrid.data("items_tablet")
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: productGrid.data("items_mobile"),
                  slidesToScroll: productGrid.data("items_mobile")
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: productGrid.data("items_mobiles"),
                  slidesToScroll: productGrid.data("items_mobiles"), arrows: !1
                }
              },
            ]
          });
        }
      });
    },

    initNovWishListsPage: function () {
      if (typeof (Storage) !== 'undefined') {
        if (wishListsArr.length <= 0) {
          return;
        }

        wishListsArr.forEach(function (item) {
          nuranium.createNovWishListTplItem(item);
        });
      } else {
        alert('Storage no support!');
      }
    },

    initNovWishListIcons: function () {
      if (!wishListsArr.length) {
        return;
      }

      for (var i = 0; i < wishListsArr.length; i++) {
        var icon = $('[data-product-handle="' + wishListsArr[i] + '"]');
        icon.addClass('whislist-added');
        icon.find('.wishlist-text').text('Remove Wish List');
      };

      if (typeof (Storage) !== 'undefined') {
        if (wishListsArr.length <= 0) {
          return;
        }

        setTimeout(function () {
          wishListsArr.forEach(function (item) {
            nuranium.setNovAddedForWishlistIcon(item);
          });
        }, 1000);
      } else {
        alert('Storage no support!');
      }
    },

    setNovAddedForWishlistIcon: function (ProductHandle) {
      var wishlistElm = $('[data-product-handle="' + ProductHandle + '"]'),
        idxArr = wishListsArr.indexOf(ProductHandle);

      if (idxArr >= 0) {
        wishlistElm.addClass('whislist-added');
        wishlistElm.find('.wishlist-text').text('Remove Wish List');
      }
      else {
        wishlistElm.removeClass('whislist-added');
        wishlistElm.find('.wishlist-text').text('Add to Wish List');
      };
    },

    doAddOrRemoveWishlist: function () {
      var iconWishLists = '.item-product [data-icon-wishlist]';

      $(document).off('click.addOrRemoveWishlist', iconWishLists).on('click.addOrRemoveWishlist', iconWishLists, function (e) {
        e.preventDefault();

        var self = $(this),
          productId = self.data('id'),
          ProductHandle = self.data('product-handle'),
          idxArr = wishListsArr.indexOf(ProductHandle);

        if (!self.hasClass('whislist-added')) {
          self.addClass('whislist-added');
          self.find('.wishlist-text').text('Remove Wish List');

          var title = self.parents('.item-product').find('.product__title').html();
          var image = self.parents('.item-product').find('.product__thumbnail').attr('src');

          $('.loading-modal').find('.product-title').html(title);
          $('.loading-modal').find('.product-image').attr('src', image);
          $('.loading-modal').find('.btn-wishlist').show();
          $('.loading-modal').css({ "display": "block", "opacity": "1", "visibility": "initial", "transform": "translateX(0)", "transition": "all 0.3s" });
          setTimeout(function () {
            $('.loading-modal').css({ "opacity": "0", "visibility": "hidden", "transform": "translateX(410px)", "transition": "all 0.3s" });
          }, 5000);

          if ($('[data-wishlist-container]').length) {
            nuranium.createNovWishListTplItem(ProductHandle);
          };

          wishListsArr.push(ProductHandle);
          localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));

        } else {
          self.removeClass('whislist-added');
          self.find('.wishlist-text').text('Add to Wish List');


          if ($('[data-wishlist-added="wishlist-' + productId + '"]').length) {
            $('[data-wishlist-added="wishlist-' + productId + '"]').remove();
          }

          wishListsArr.splice(idxArr, 1);
          localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));
        };

        nuranium.setNovAddedForWishlistIcon(ProductHandle);
      });
    },

    createNovWishListTplItem: function (ProductHandle) {
      var wishListCotainer = $('[data-wishlist-container]');

      jQuery.getJSON(window.router + '/products/' + ProductHandle + '.js', function (product) {
        var productHTML = '',
          price_min = Shopify.formatMoney(product.price_min, "${{amount}}");

        productHTML += '<div class="grid-item" data-wishlist-added="wishlist-' + product.id + '">';
        productHTML += '<div class="inner item-product row align-items-center" data-product-id="product-' + product.handle + '">';
        productHTML += '<div class="column_content col-xl-5 col-lg-5 col-md-4 col-sm-12 col-xs-12"><div class="product-image">';
        productHTML += '<a href="' + product.url + '" class="product-grid-image" data-collections-related="/collections/all?view=related">';
        productHTML += '<img src="' + product.featured_image + '" alt="' + product.featured_image.alt + '">';
        productHTML += '</a></div>';
        productHTML += '<div class="product-info">';
        productHTML += '<div class="product-title">';
        productHTML += '<a href="' + product.url + '" title="' + product.title + '">' + product.title + '</a></div></div></div>';
        productHTML += '<div class="column_content col-xl-3 col-lg-3 col-md-2 col-sm-12 col-xs-12 text-center"><div class="price-box">' + price_min + '</div></div>';
        productHTML += '<div class="column_content col-xl-2 col-lg-2 col-md-3 col-sm-12 col-xs-12 text-center"><a class="btn whislist-added" href="#" data-product-handle="' + product.handle + '" data-icon-wishlist data-id="' + product.id + '"><i class="fa fa-trash-o" aria-hidden="true"></i>' + theme.strings.remove + '</a></div>';
        productHTML += '<div class="column_content col-xl-2 col-lg-2 col-md-3 col-sm-12 col-xs-12 text-center">';
        productHTML += '<form action="/cart/add" method="post" class="variants formAddToCart" id="-' + product.id + '" data-id="product-actions-' + product.id + '" enctype="multipart/form-data">';

        if (product.available) {
          if (product.variants.length == 1) {
            productHTML += '<button class="btn btnAddToCart" type="submit" data-form-id="#-' + product.id + '" data-pid="' + product.variants[0].id + '" ><i class="zmdi zmdi-shopping-cart"></i><span>' + theme.strings.addToCart + '</span></button><input type="hidden" name="id" value="' + product.variants[0].id + '" />';
          }
          if (product.variants.length > 1) {
            productHTML += '<a class="btn btnAddToCart btnChooseVariant" title="' + product.title + '" href="javascript:void(0);" data-url="' + product.url + '?view=json"><i class="zmdi zmdi-check"></i><span>' + theme.strings.select_options + '</span></a>';
          }
        } else {
          productHTML += '<button class="btn btnAddToCart" type="button" disabled="disabled">' + theme.strings.soldOut + '</button>';
        }

        productHTML += '</form></div>';

        productHTML += '</div></div>';

        wishListCotainer.append(productHTML);
      });
    },

    ajaxAddToCart: function () {
      $(document).on('click', 'button.btnAddToCart', function (e) {
        e.preventDefault();
        var $this = $(this),
          variant_id = $this.data('pid');
        $this.addClass('btn-loading');
        $this.parent().addClass('fix_nt_tt');
        $('body').addClass('loading');

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { quantity: 1, id: variant_id },
          dataType: 'json',
          success: function (cart) {
            $.get('/cart?view=json', function (data) {
              $('#cart-info').html(data);
            }).always(function () {
              Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

              nuranium.initAddToCart(cart.image, cart.title);

              nuranium.updateMiniCart();

              nuranium.PopupAddToCart();

              nuranium.initQuickVariants();

              $this.removeAttr("disabled").css('pointer-events', 'auto').removeClass("btn-loading");
              $('body').removeClass('loading');

              $(document).find('.quickviewClose').trigger('click');
            });
          },
          error: function (XMLHttpRequest, textStatus) {
            $this.removeClass("btn-loading");

          }
        }).done(function () {
          $('body').removeClass('loading');
        });
      })
    },

    openCartDrawer: function () {
      var $drawer = $('#cart-drawer');
      var $overlay = $('#cart-drawer-overlay');
      var $body = $('#cart-drawer-body');

      if (!$drawer.length) return;

      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (!$('body').hasClass('cart-drawer-open')) {
        document.body.dataset.cartScrollY = scrollY;
        document.body.style.top = '-' + scrollY + 'px';
      }

      $drawer.css('visibility', 'visible');
      $drawer.attr('aria-hidden', 'false');
      $overlay.addClass('is-visible');
      $drawer.addClass('is-open');
      $('html, body').addClass('cart-drawer-open');

      $body.html('<div class="text-center py-30" style="padding: 40px 0; text-align: center;"><i class="zmdi zmdi-spinner zmdi-hc-spin zmdi-hc-2x" style="font-size: 28px; color: #00aac9;"></i></div>');

      $.ajax({
        url: '/cart/?view=upsell',
        dataType: 'html',
        type: 'GET',
        success: function (data) {
          $body.html(data);
          nuranium.PopupAddToCart();
          nuranium.initCartDrawerRecEvents();
          $.get('/cart.js', function (cart) {
            if (cart) {
              $('#cart-drawer-count').text(cart.item_count);
              $('#CartCount').text(cart.item_count);
              $('#_mobile_cart_count').text(cart.item_count);
            }
          }, 'json');
        },
        error: function () {
          $body.html('<div class="text-center py-20">Error loading cart drawer.</div>');
        }
      });
    },

    closeCartDrawer: function () {
      $('#cart-drawer-overlay').removeClass('is-visible');
      var $drawer = $('#cart-drawer');
      $drawer.removeClass('is-open');
      $drawer.attr('aria-hidden', 'true');
      var scrollY = parseInt(document.body.dataset.cartScrollY || '0', 10);
      $('html, body').removeClass('cart-drawer-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      delete document.body.dataset.cartScrollY;
      window.scrollTo(0, scrollY);
      setTimeout(function () {
        if (!$drawer.hasClass('is-open')) {
          $drawer.css('visibility', 'hidden');
        }
      }, 350);
    },

    initCartDrawerRecEvents: function () {
      $(document).off('click.recAdd', '.btn-rec-add-drawer').on('click.recAdd', '.btn-rec-add-drawer', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $form = $btn.closest('form');
        var variantId = $form.find('input[name="id"]').val();
        $btn.prop('disabled', true).text('Adding...');

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { id: variantId, quantity: 1 },
          dataType: 'json',
          success: function () {
            nuranium.openCartDrawer();
          },
          error: function (err) {
            $btn.prop('disabled', false).text('+ Add');
            alert('Could not add item to cart.');
          }
        });
      });
    },

    initAddToCart: function (image, title) {
      if ($('#cart-drawer').length > 0) {
        nuranium.openCartDrawer();
        return;
      }
      $.ajax({
        url: '/cart/?view=upsell',
        dataType: 'html',
        type: 'GET',
        beforeSend: function () {
          $('body').addClass('cart_popup_opened');
          $('body').addClass('loading');
          $('#jas-wrapper').after('<div class="loader"><div class="loader-inner"></div></div>');
        },
        success: function (data) {
          $.magnificPopup.open({
            items: {
              src: '<div class="nov-with-anim product-quickview popup-quick-view cart__popup cart__popup_upsell"><div id="content_cart__popup_nt">' + data + '</div></div>',
              type: 'inline'
            },
            removalDelay: 500,
            callbacks: {
              beforeOpen: function () {
                this.st.mainClass = 'nov-move-horizontal';
              },
              open: function () {
                nuranium.PopupAddToCart();
                nuranium.initQuickVariants();
                Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
              },
              change: function () { },
              close: function () {
                if ($('body').hasClass('template-cart')) {
                  window.location.reload();
                }
                else {
                  $('body').removeClass('cart_popup_opened');
                  $('body').removeClass('open_quick_variants');
                  $('body').removeClass('loading');
                  $('#content_cart__popup_nt').empty();
                }
              }
            },
          });
        },
        complete: function () {
          nuranium.PopupAddToCart();
          Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
          $('.loader').remove();
        },
        error: function () {
          $('.loader').remove();
        }
      });
    },

    updateMiniCart: function () {
      Shopify.getCart(function (cart) {
        nuranium.doUpdateMiniCart(cart);
      });
      nuranium.initMiniCart();
    },

    doUpdateMiniCart: function (cart) {
      $('#CartCount').text(cart.item_count);
      $('.cart-popup-heading span').html('There are ' + cart.item_count + ' item(s) in your cart');
      if (cart.item_count === 0) {
        $('#cart-info').slideUp('fast');
        if ($.magnificPopup && $.magnificPopup.instance && $.magnificPopup.instance.isOpen) {
          $.magnificPopup.close();
        }
      }
    },

    ajaxChangeFromCart: function () {
      $(document).on('change', '.cart__popup-qty--input', function (e) {
        e.preventDefault();
      })
    },

    PopupAddToCart: function () {
      function PopupUpdateCart(_id, new_qty) {
        $('.cart__popup').addClass('loading');
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + new_qty + '&id=' + _id,
          dataType: 'json',
          success: function (cart) {
            if ($('#cart-drawer').length > 0) {
              nuranium.openCartDrawer();
              return;
            }
            jQuery.get('/cart?view=up_ajax', function (data) {
              data = jQuery(data);
              var sdata = jQuery(data);
              var t_html = jQuery(sdata.get(0)).html(),
                t_threshold = jQuery(sdata.get(2)).html(),
                t_total = $('.cart__popup #' + _id).find('.cart__popup-total .amount');

              $('.cart__popup #' + _id).find('.cart__popup-qty--input').val(new_qty);

              var price = parseFloat(t_total.data('price')) * new_qty;
              t_total.html(Shopify.formatMoney(price, theme.moneyFormat));
              $('#cart__popup_total').html(t_html);
              $('#threshold_bar_popup').html(t_threshold);
            }).always(function () {
              Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
              $('.cart__popup').removeClass('loading');
            });

            $.get('/cart?view=json', function (data) {
              $('#cart-info').html(data);
            }).always(function () {
              Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
              nuranium.updateMiniCart();
            });
          },
          error: function (XMLHttpRequest, textStatus) {
            $('.cart__popup').removeClass('loading');
          }
        });
      }

      $(document).off('click.cartPopupQty', '.cart__popup-qty').on('click.cartPopupQty', '.cart__popup-qty', function (e) {
        e.preventDefault();

        var $this = $(this),
          $qty = $this.siblings('.cart__popup-qty--input'),
          $id = $qty.attr('data-key') || $qty.attr('data-id'),
          $qtyinput = parseFloat($qty.val()),
          $step = parseFloat($qty.attr('step')) || 1,
          $min = parseFloat($qty.attr('min')) || 1,
          $max = parseFloat($qty.attr('max')) || 9999;

        if ($this.hasClass('cart__popup-qty--plus')) {
          var $newqty = $qtyinput + $step;
          if ($newqty > $max && $max > 0) {
            $qty.val($max);
            // alert('Maximum Quantity: ' + $max);
            return;
          }
        }
        else if ($this.hasClass('cart__popup-qty--minus')) {
          var $newqty = $qtyinput - $step;
          if ($newqty === 0) {
            var last_qty = parseInt($qty.attr('value')) || 1;
            $qty.val(last_qty);
            $this.closest('.cart__popup-item').find('.cart__popup-remove').trigger('click');
            return;
          } else if ($newqty < $min) {
            return;
          } else if ($qtyinput < 0) {
            alert('Invalid');
            return;
          }
        }

        PopupUpdateCart($id, $newqty);
      });

      $(document).off('click.cartPopupRemove', '.cart__popup-remove').on('click.cartPopupRemove', '.cart__popup-remove', function (e) {
        e.preventDefault();

        var $this = $(this),
          $itemCard = $this.closest('.cart__popup-item'),
          $qty = $itemCard.find('.cart__popup-qty--input'),
          $id = $this.find('a').attr('data-product-id') || $this.attr('data-product-id') || $qty.attr('data-key') || $qty.attr('data-id'),
          $qtyinput = parseInt($qty.val()) || 0,
          $ptitle = $itemCard.find('.cart__popup-title a').text() || $itemCard.find('a[href*="/products/"]').text();

        if (!$id) return;

        $('.cart__popup').addClass('loading');

        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=0&id=' + $id,
          dataType: 'json',
          success: function (cart) {
            if ($('#cart-drawer').length > 0) {
              nuranium.openCartDrawer();
              return;
            }
            jQuery.get('/cart?view=up_ajax', function (data) { }).always(function (data) {
              data = jQuery(data);
              var sdata = jQuery(data);
              var t_html = jQuery(sdata.get(0)).html(),
                t_threshold = jQuery(sdata.get(2)).html();;
              $('#cart__popup_total').html(t_html);
              $('#threshold_bar_popup').html(t_threshold);
              $('.cart__popup #' + $id).addClass('hide');
              if ($qtyinput > 0) {
                $('#' + $id + ' input').val($qtyinput)
              } else {
                $('.cart__popup #' + $id + ' input').val(1)
              }

              Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

              $('.cart__popup .cart-message').html('<i class="fa fa-trash-o"></i> <strong>' + $ptitle + '</strong> - has been removed into your shopping cart.');

              $('.cart__popup .cart-message').removeClass('removed').addClass('removed');

              $('.cart__popup').removeClass('loading');

              $this.parents('.cart__popup-item').remove();
            });

            $.get('/cart?view=json', function (data) {
              $('#cart-info').html(data);
            }).always(function () {
              Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

              nuranium.updateMiniCart();
            });
          },
          error: function (XMLHttpRequest, textStatus) {
            $('.cart__popup').removeClass('loading');
          }
        });
      });
    },


    initMiniCart: function () {
      jQuery.getJSON("/cart.js", function (cart) {
        $('#CartCount').text(cart.item_count);
        $('#cart-info').html('');
        if (cart.item_count > 0) {
          var html = '';
          html += '<form action="/cart" method="post" class="cart ajaxcart">';
          html += '<div class="ajaxcart__inner">';
          for (var i = 0; i < cart.items.length; i++) {

            // if (
            //   cart.items[i].properties &&
            //   cart.items[i].properties._hidden === "true"
            // ) {
            //   continue;
            // }

            var image = Shopify.resizeImage(cart.items[i].image, 'small');
            var price = Shopify.formatMoney(cart.items[i].price, theme.moneyFormat);

            html += '<div class="ajaxcart__product" data-line="' + i + '">';
            html += '<div class="media">';
            if (image) {
              html += '<a href="' + cart.items[i].url + '"><img class="d-flex product-image" src="' + image + '" alt="' + cart.items[i].title + '" title="' + cart.items[i].title + '"></a>';
            } else {
              html += '<a href="' + cart.items[i].url + '"><img class="d-flex product-image" src="https://a294e6-2.myshopify.com/cdn/shop/t/7/assets/globber-placeholder.png?v=44425985884756667301718947212" alt="' + cart.items[i].title + '" title="' + cart.items[i].title + '"></a>';
            }
            html += '<div class="media-body">';
            html += '<a class="product-name" href="' + cart.items[i].url + '" style="font-weight: 700; color: #000;">' + cart.items[i].title + '</a>';
            html += '<div class="mb-5">';

            if (cart.items[i].properties) {
              if (cart.items[i].properties._bundle_components) {
                var comps = cart.items[i].properties._bundle_components.split('|||');
                html += '<div class="cart-bundle-nested-list mt-5" style="margin-top: 6px; display: flex; flex-direction: column; gap: 6px;">';
                for (var c = 0; c < comps.length; c++) {
                  var parts = comps[c].split(':::');
                  html += '<div class="cart-bundle-nested-item d-flex align-items-center" style="display: flex; align-items: center; background: #f9f9f9; padding: 4px 8px; border-radius: 8px; gap: 8px;">';
                  if (parts[2]) {
                    html += '<div class="cart-bundle-nested-thumb-wrap"><img src="' + parts[2] + '" alt="' + parts[0] + '" class="cart-bundle-nested-thumb" style="width: 36px; height: 36px; min-width: 36px; object-fit: cover; border-radius: 6px; border: 1px solid #eee; background: #fff;"></div>';
                  }
                  html += '<div class="cart-bundle-nested-details">';
                  html += '<div class="cart-bundle-nested-title" style="font-size: 12px; font-weight: 600; color: #222; line-height: 1.2;">' + parts[0] + '</div>';
                  if (parts[1] && parts[1].trim() !== '' && !parts[1].includes('Default')) {
                    html += '<div class="cart-bundle-nested-option" style="font-size: 11px; color: #666; margin-top: 1px;">' + parts[1] + '</div>';
                  }
                  html += '</div>';
                  html += '</div>';
                }
                html += '</div>';
              } else {
                for (var key in cart.items[i].properties) {
                  if (
                    cart.items[i].properties[key] &&
                    key.charAt(0) !== '_'
                  ) {
                    html += '<div class="ajaxcart__product-meta" style="font-size: 12px; color: #444;"><strong>' +
                      key +
                      ':</strong> ' +
                      cart.items[i].properties[key] +
                      '</div>';
                  }
                }
              }
            }

            html += '</div>';
            html += '<span class="product-price"><span class="money">' + price + ' GBP</span></span>';
            html += '<span class="quantity"> x ' + cart.items[i].quantity + '</span>';
            html += '<a class="remove-from-cart" rel="nofollow" href="#" title="remove from cart" data-line="' + i + '" data-product-id="' + cart.items[i].id + '"><i class="fa fa-trash-o" aria-hidden="true"></i></a>';
            html += '</div>';
            html += '</div>';
            html += '</div>';
          }
          html += '</div>';

          var price = cart.total_price;
          var freeshipping_value = theme.freeshipping_value;


          html += '<div class="ajaxcart__footer" style="border-top: 1px dashed #ddd; padding-top: 15px; margin-top: 15px;">';
          html += '<div class="subtotal d-flex align-items-center justify-content-between" style="font-weight: 800; font-size: 16px;">';
          html += '<label style="font-weight: 800; text-transform: uppercase;">' + theme.strings.total + '</label>';
          html += '<span class="money" style="font-weight: 800;">' + Shopify.formatMoney(cart.total_price, theme.moneyFormat) + ' GBP</span>';
          html += '</div>';

          html += '<div class="btn_submit" style="margin-top: 15px; display: flex; flex-direction: column; gap: 10px;">';
          html += '<button type="submit" class="btn cart__checkout" name="checkout" style="background-color: #00aac9 !important; color: #ffffff !important; border-radius: 30px !important; width: 100%; height: 46px !important; line-height: 1 !important; padding: 0 !important; margin: 0 !important; font-weight: 700; font-size: 16px; border: none; cursor: pointer; display: flex !important; align-items: center !important; justify-content: center !important;"><span style="display: inline-block; line-height: 1; margin: 0; padding: 0;">' + theme.strings.check_out + '</span></button>';
          html += '<a href="/cart" class="btn btn-view-cart" style="background-color: #ffffff !important; color: #00aac9 !important; border: 2px solid #00aac9 !important; border-radius: 30px !important; width: 100%; height: 46px !important; line-height: 1 !important; padding: 0 !important; margin: 0 !important; font-weight: 700; font-size: 16px; display: flex !important; align-items: center !important; justify-content: center !important; text-decoration: none;"><span style="display: inline-block; line-height: 1; margin: 0; padding: 0;">' + theme.strings.view_cart + '</span></a>';
          html += '</div>';
          html += '</div>';
          html += '</form>';
          $('#cart-info').append(html);

          Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
        } else {
          $('#cart-info').append('<div class="ajaxcart__empty p-3 text-center" style="padding: 15px; text-align: center;">Your cart is empty.</div>');
        }
      })
    },

    ajaxProductAddToCart: function () {
      $(document).off('click.productAddToCart', '.product-form__cart-submit').on('click.productAddToCart', '.product-form__cart-submit', function (e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.hasClass('btn--loader-active') || $this.is(':disabled')) return false;

        $this.attr('disabled', 'disabled').css('pointer-events', 'none').addClass('btn--loader-active');
        var $form = $this.closest('form');

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: $form.serialize(),
          dataType: 'json',
          success: function (cart) {
            $.get('/cart?view=json', function (data) {
              $('#cart-info').html(data);
            }).always(function () {
              if (typeof Currency !== 'undefined' && typeof shopCurrency !== 'undefined') {
                Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
              }

              var img = cart ? (cart.image || (cart.items && cart.items[0] && cart.items[0].image) || '') : '';
              var title = cart ? (cart.title || (cart.items && cart.items[0] && cart.items[0].title) || '') : '';

              if (typeof nuranium !== 'undefined') {
                if (typeof nuranium.initAddToCart === 'function') {
                  nuranium.initAddToCart(img, title);
                }
                if (typeof nuranium.updateMiniCart === 'function') {
                  nuranium.updateMiniCart();
                }
                if (typeof nuranium.PopupAddToCart === 'function') {
                  nuranium.PopupAddToCart();
                }
              }

              $this.removeAttr('disabled').css('pointer-events', 'auto').removeClass('btn--loader-active');
              $(document).find('.quickviewClose').trigger('click');
            });
          },
          error: function (xhr, textStatus, errorThrown) {
            $this.removeAttr('disabled').css('pointer-events', 'auto').removeClass('btn--loader-active');
            var errMsg = 'Unable to add item to cart.';
            if (xhr && xhr.responseJSON && xhr.responseJSON.description) {
              errMsg = xhr.responseJSON.description;
            }
            alert(errMsg);
          },
          complete: function () {
            $('body').removeClass('cart_popup_opened loading');
            $('.nov-close, .cart_popup_opened .nov-ready').off('click.cartReload').on('click.cartReload', function () {
              if ($('body').hasClass('template-cart')) {
                window.location.reload();
              }
            });
          }
        });
      });
    },

    initQuickView: function () {
      $(document).on('click', '.btnProductQuickview', function (e) {
        e.preventDefault();

        var $this = $(this);

        $.ajax({
          beforeSend: function () {
            $this.addClass('btn-loading');
            $('body').addClass('open_gl_quick_view');
            $('body').addClass('loading');
          },
          url: $this.attr('data-url'),
          success: function (data) {
            $.magnificPopup.open({
              items: {
                src: '<div class="nov-with-anim popup-quick-view" id="content_quickview">' + data + '</div>', // can be a HTML string, jQuery object, or CSS selector
                type: 'inline'
              },
              removalDelay: 500, //delay removal by X to allow out-animation
              callbacks: {
                beforeOpen: function () {
                  this.st.mainClass = 'nov-move-horizontal';
                },
                open: function () {
                  if ($('html').hasClass('lang-rtl'))
                    rtl = true;
                  else
                    rtl = false;
                  var autoplay = $("#productThumbs .owl-carousel").data('autoplay');
                  var autoplayTimeout = $("#productThumbs .owl-carousel").data('autoplayTimeout');
                  var items = $("#productThumbs .owl-carousel").data('items');
                  var margin = $("#productThumbs .owl-carousel").data('margin');
                  var nav = $("#productThumbs .owl-carousel").data('nav');
                  var dots = $("#productThumbs .owl-carousel").data('dots');
                  var loop = $("#productThumbs .owl-carousel").data('loop');
                  var items_tablet = $("#productThumbs .owl-carousel").data('items_tablet') ? $("#productThumbs .owl-carousel").data('items_tablet') : 3;
                  var items_mobile = $("#productThumbs .owl-carousel").data('items_mobile') ? $("#productThumbs .owl-carousel").data('items_mobile') : 1;
                  var center = $("#productThumbs .owl-carousel").data('center') ? $("#productThumbs .owl-carousel").data('center') : false;
                  var start = $("#productThumbs .owl-carousel").data('start') ? $("#productThumbs .owl-carousel").data('start') : 0;
                  $("#productThumbs .owl-carousel").owlCarousel({
                    navText: ['<i class="fa fa-long-arrow-left"></i>', '<i class="fa fa-long-arrow-right"></i>'],
                    lazyLoad: true,
                    lazyContent: true,
                    loop: loop,
                    autoplay: autoplay,
                    autoplayTimeout: autoplayTimeout,
                    items: items,
                    margin: margin,
                    rtl: rtl,
                    dots: dots,
                    nav: nav,
                    responsive: {
                      0: {
                        items: items_mobile,
                        center: center,
                        margin: 10
                      },
                      768: {
                        items: items_tablet,
                        margin: 10
                      },
                      992: {
                        items: items,
                        margin: margin
                      },
                      1200: {
                        items: items,
                        startPosition: start,
                        margin: margin
                      },
                    }
                  });
                  Shopify.PaymentButton.init();

                  Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

                  setTimeout(function () {
                    if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
                      return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                    };
                  }, 1000);

                  jQuery(function () {
                    jQuery('.swatch :radio').change(function () {
                      var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                      var optionValue = jQuery(this).val();
                      jQuery(this)
                        .closest('form')
                        .find('.single-option-selector')
                        .eq(optionIndex)
                        .val(optionValue)
                        .trigger('change');

                      $(this).parents('.watch_availabel').find('span.variant_current').text(optionValue);


                    });
                  });
                },
                close: function () {
                  $('#content_quickview').empty();
                  $('body').removeClass('open_gl_quick_view');
                  $('body').removeClass('cart_popup_opened');
                  $('body').removeClass('open_quick_variants');
                  $('body').removeClass('loading');
                }
              },
            });
          },
          complete: function () {
            Shopify.PaymentButton.init();
          }
        }).done(function () {
          $this.removeClass('btn-loading');
        })
      })
    },

    initQuickVariants: function () {
      $(document).on('click', '.btnChooseVariant', function (e) {
        e.preventDefault();

        var $this = $(this);

        $.ajax({
          beforeSend: function () {
            $this.addClass('btn-loading');
            $('body').addClass('open_quick_variants');
            $('body').addClass('loading');

          },
          url: $this.attr('data-url'),
          success: function (data) {
            $.magnificPopup.open({
              items: {
                src: '<div class="nov-with-anim popup-quick-view" id="content_variants">' + data + '</div>', // can be a HTML string, jQuery object, or CSS selector
                type: 'inline'
              },
              removalDelay: 500, //delay removal by X to allow out-animation
              callbacks: {
                beforeOpen: function () {
                  this.st.mainClass = 'nov-move-horizontal';
                },
                open: function () {
                  Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

                  jQuery(function () {
                    jQuery('.swatch :radio').change(function () {
                      var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                      var optionValue = jQuery(this).val();
                      jQuery(this)
                        .closest('form')
                        .find('.single-option-selector')
                        .eq(optionIndex)
                        .val(optionValue)
                        .trigger('change');

                      $(this).parents('.watch_availabel').find('span.variant_current').text(optionValue);
                    });
                  });

                  nuranium.PopupAddToCart();
                },
                close: function () {
                  if ($('body').hasClass('template-cart')) {
                    window.location.reload();
                  }
                  else {
                    $('#content_variants').empty();
                    $('body').removeClass('open_quick_variants');
                    $('body').removeClass('cart_popup_opened');
                    $('body').removeClass('loading');
                  }
                }
              },
            });
          },
          complete: function () {
            Shopify.PaymentButton.init();

            jQuery(function () {
              jQuery('.swatch :radio').change(function () {
                var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                var optionValue = jQuery(this).val();
                jQuery(this)
                  .closest('form')
                  .find('.single-option-selector')
                  .eq(optionIndex)
                  .val(optionValue)
                  .trigger('change');

                $(this).parents('.watch_availabel').find('span.variant_current').text(optionValue);
              });
            });
          }
        }).done(function () {
          $this.removeClass('btn-loading');
          $('body').removeClass('loading');
        })
      })
    },

    ajaxRemoveFromCart: function () {
      $('#cart-info').on('click', '.remove-from-cart', function (e) {
        e.preventDefault();

        var $this = $(this),
          $id = $this.attr('data-product-id');

        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=0&id=' + $id,
          dataType: 'json',
          success: function (cart) {
            if ($('body').hasClass('template-cart')) {
              window.location.reload();
            }
            else {
              nuranium.initMiniCart();
            }
          }
        })
      });
    },

    changeQuantityPageCart: function () {
      function ShopifyCartChange(variant_id, quantity, callback) {
        var params = {
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + quantity + '&line=' + variant_id,
          dataType: 'json',
          success: function (cart) {
            if ((typeof callback) === 'function') {
              callback(cart);
            }
          },
          error: function (XMLHttpRequest, textStatus) {

          }
        };
        jQuery.ajax(params);
      }

      $(document).on('change keyup', '.cart__qty-input', function () {
        var $this = $(this);
        var line = $this.data('line'),
          val = parseInt($this.val()),
          price = $this.data('price'),
          max = $this.attr('max');
        if (isNaN(val)) return 0;

        max = isNaN(parseInt(max)) ? 9999 : parseInt(max);
        if (val > max) {
          $this.attr('value', max).val(max);
        }
        val = (val > max) ? max : val;

        if (val <= 0) {
          $this.closest('tr').remove();
        }

        ShopifyCartChange(line, val, function (res) {
          $('.cart__subtotal').html(Shopify.formatMoney(res.total_price, theme.moneyFormat));

          $this.parents('.cart_item').find('.product-subtotal').html(Shopify.formatMoney(price * val, theme.moneyFormat));

          $('#CartCount').html(res.item_count);

          $('.cart__heading span').html('There are ' + res.item_count + ' items in your cart');

          Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

          jQuery.get('/cart?view=ship', function (data) {
            $('#threshold_bar_popup').html(data);
            setTimeout(function () {
              Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
            }, 200);
          });
        });
      });

      $(document).on('click', '.plus, .minus', function () {
        var $qty = $(this).closest('.cart__qty').find('.cart__qty-input'),
          currentVal = parseFloat($qty.val()),
          max = parseFloat($qty.attr('max')),
          min = parseFloat($qty.attr('min')),
          step = $qty.attr('step');

        if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
        if (max === '' || max === 'NaN') max = '';
        if (min === '' || min === 'NaN') min = 0;
        if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;

        if ($(this).is('.plus')) {
          if (max && (currentVal >= max)) {
            $qty.val(max);
          } else {
            $qty.val((currentVal + parseFloat(step)));
          }
        } else {
          if (min && (currentVal <= min)) {
            $qty.val(min);
          } else if (currentVal > 0) {
            $qty.val((currentVal - parseFloat(step)));
          }
        }
        $qty.trigger('change');
      });

      $(document).on('click', '.quick_view-qty-plus, .quick_view-qty-minus', function () {
        var $qty = $(this).closest('.quick_view_qty').find('input[name="quantity"]'),
          currentVal = parseFloat($qty.val()),
          max = parseFloat($qty.attr('max')),
          min = parseFloat($qty.attr('min')),
          step = $qty.attr('step');

        if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
        if (max === '' || max === 'NaN') max = '';
        if (min === '' || min === 'NaN') min = 0;
        if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;

        if ($(this).is('.quick_view-qty-plus')) {
          if (max && (currentVal >= max)) {
            $qty.val(max);
          } else {
            $qty.val((currentVal + parseFloat(step)));
          }
        } else {
          if (min && (currentVal <= min)) {
            $qty.val(min);
          } else if (currentVal > 0) {
            $qty.val((currentVal - parseFloat(step)));
          }
        }
      });
    }
  }


  // FIX: Attach decoupled document event listeners instantly to avoid defer/ready race condition 
  $(document).on('click', '#cart-drawer-close-btn, #cart-drawer-close, #cart-drawer-overlay', function (e) {
    e.preventDefault();
    if (window.nuranium && typeof window.nuranium.closeCartDrawer === 'function') {
      window.nuranium.closeCartDrawer();
    }
  });

  $(document).on('click', '#cart_block, .site-header__cart, .stickymenu-item a[href*="cart"], [data-target="#mobile-blockcart"], .nov-toggle-page[data-target="#mobile-blockcart"]', function (e) {
    if ($('#cart-drawer').length > 0) {
      e.preventDefault();
      e.stopPropagation();
      if (window.nuranium && typeof window.nuranium.openCartDrawer === 'function') {
        window.nuranium.openCartDrawer();
      }
    }
  });

  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      if (window.nuranium && typeof window.nuranium.closeCartDrawer === 'function') {
        window.nuranium.closeCartDrawer();
      }
    }
  });

  // Prevent background swiping / touch scrolling when cart drawer is open
  document.addEventListener('touchmove', function (e) {
    if (document.body.classList.contains('cart-drawer-open') || document.documentElement.classList.contains('cart-drawer-open')) {
      var isScrollable = e.target.closest('.cart-drawer-scrollable-area, .cart-drawer-recommendations-list');
      if (!isScrollable && e.cancelable) {
        e.preventDefault();
      }
    }
  }, { passive: false });

  window.nuranium = nuranium;
  $(document).ready(function () {
    nuranium.init();
  });
})(jQuery);


